import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a envelope icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/envelope?f=classic&s=solid
 */
export const EnvelopeIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faEnvelope} {...props} />;
};
